import ManageUsersPage from './ManageUsers';

export default ManageUsersPage;
